import React from 'react';
import { Row, Col, Typography, Divider } from 'antd';

const { Title, Paragraph } = Typography;

const InfoMenu = ({ sections }) => {
  return (
    <div
      style={{
        background: 'pink',
        border: '1px solid #D6D8E7',
        paddingLeft: '24px',
        paddingRight: '24px',
        paddingTop: '24px'
      }}
    >
      {sections.map(({ title, subtitle, child }, index) => {
        return (
          <Row key={index}>
            <Col span={24}>
              <Row>
                <Title level={5}>{title}</Title>
              </Row>
              <Row>
                <Paragraph style={{ textAlign: 'start' }}>{subtitle}</Paragraph>
              </Row>
              <Row align="middle" justify="center">
                {child()}
              </Row>
              <Divider />
            </Col>
          </Row>
        );
      })}
    </div>
  );
};

export default InfoMenu;
